import * as React from 'react'
import NumberFieldInnerTable from '../../inputs/NumberFieldInnerTable'

const MedicalCover = ({ data, setData }) => {
  React.useEffect(() => {
    if (
      data.isDeductionForMedicalInsuranceEnabled === false &&
      'deductionForMedicalInsurance' in data
    ) {
      const { deductionForMedicalInsurance, ...rest } = data
      setData(rest)
    }
  }, [data])
  return (
    <div className="tw-flex tw-items-end tw-justify-between tw-gap-2 tw-px-5 tw-pt-3">
      <NumberFieldInnerTable
        innerLabel="PLN"
        placeholder="0,00"
        value={data?.deductionForMedicalInsurance?.toString() || ''}
        onChange={(e) => {
          setData({
            ...data,
            deductionForMedicalInsurance: Number(e.target.value),
          })
        }}
      />
    </div>
  )
}

export default MedicalCover
